import classnames from 'classnames/bind';

import AIModel from 'types/ai_model';

import { useModels } from 'hooks/api/useModels';
import { usePlanCapability } from 'organizations/hooks/usePlanCapability';

import * as PageLayout from 'components/PageLayout';
import { AdvancedSearch } from 'components/AdvancedSearch/AdvancedSearch';
import { EmptyView } from 'components/EmptyView/EmptyView';
import { ModelGrid } from 'analytics-library/components/ModelGrid/ModelGrid';

import EmptyIllustration from 'analytics-library/images/empty-models-illustration.svg?react';
import styles from './AIModels.module.scss';

const c = classnames.bind(styles);

const EMPTY_MODELS: AIModel[] = [];

export function AIModels() {
  const { isDisabled: isCustomModelsDisabledByPlan, isLoading: isPlanLoading } =
    usePlanCapability('can_create_custom_models');
  const { data: models, isLoading: isLoadingModels } = useModels();

  if (isCustomModelsDisabledByPlan) {
    return (
      <PageLayout.Root>
        <div className={c('empty')}>
          <EmptyView
            image={EmptyIllustration}
            title="Upgrade to import and create custom models"
          >
            Custom model import and creation are not included in your current
            plan.
          </EmptyView>
        </div>
      </PageLayout.Root>
    );
  }

  return (
    <PageLayout.Root>
      <AdvancedSearch
        data={models || EMPTY_MODELS}
        isLoading={isPlanLoading || isLoadingModels}
        searchLabel="Search models"
        entity="models"
        searchOnInputChange
      >
        <ModelGrid />
      </AdvancedSearch>
    </PageLayout.Root>
  );
}
